import {
    Component,
    EventEmitter,
    Output
} from '@angular/core';
import { IDynamicComponent } from '../../../../../../../lib-dynamic-component/i-dynamic-component';
import { ToolboxListTypes } from '../toolbox-list-group/toolbox-list-types';

@Component({
    template: `
        <h2>Элементы</h2>
        <div class="list">
            <div class="card"
                libDraggable
                (libDraggableDragStart)="dragStart.emit('text')">
                <div class="card__icon">
                    <img src="/assets/element-text-icon.png"
                        draggable="false"
                        alt="">
                </div>
                <div class="card__title">
                    Текст
                </div>
            </div>
            <div class="card"
                libDraggable
                (libDraggableDragStart)="dragStart.emit('button')">
                <div class="card__icon">
                    <img src="/assets/element-button-icon.png"
                        draggable="false"
                        alt="">
                </div>
                <div class="card__title">
                    Кнопка
                </div>
            </div>
            <div class="card"
                libDraggable
                (libDraggableDragStart)="dragStart.emit('image')">
                <div class="card__icon">
                    <img src="/assets/element-image-icon.png"
                        draggable="false"
                        alt="">
                </div>
                <div class="card__title">
                    Картинка
                </div>
            </div>
            <div class="card"
                libDraggable
                (libDraggableDragStart)="dragStart.emit('separator')">
                <div class="card__icon">
                    <img src="/assets/element-separator-icon.png"
                        draggable="false"
                        alt="">
                </div>
                <div class="card__title">
                    Разделитель
                </div>
            </div>
            <div class="card"
                libDraggable
                (libDraggableDragStart)="dragStart.emit('html')">
                <div class="card__icon">
                    <img src="/assets/element-html-icon.png"
                        draggable="false"
                        alt="">
                </div>
                <div class="card__title">
                    HTML-блок
                </div>
            </div>
        </div>
    `,
    styles: [`
        h2 {
            display: flex;
            margin: 0;
            padding: 0 10px;
            height: 32px;
            align-items: center;
        }

        .list {
            display: flex;
            flex-wrap: wrap;
        }

        .card {
            width: 70px;
            margin: 0 5px;
            margin-bottom: 10px;

            background-color: #ffffff;

            user-select: none;
        }

        .card:hover {
            box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
        }

        .card__icon {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 55px;
        }

        .card__title {
            height: 35px;

            font-size: 11px;
            line-height: 15px;

            text-align: center;
            color: #333333;
        }
    `],
})
export class ElementListComponent
    implements IDynamicComponent<ToolboxListTypes> {
    model: ToolboxListTypes;
    @Output() dragStart = new EventEmitter<string>();
}
